import { useState } from 'react';
import { Button } from 'antd';

import { RawModal } from './RawModal';

export const RawAction = ({ id }: { id: number }) => {
  const [transactionId, setTransactionId] = useState<number>();

  return (
    <>
      <RawModal
        transactionId={transactionId}
        setTransactionId={setTransactionId}
      />

      <Button
        type='link'
        onClick={() => setTransactionId(id)}
        className='p-0 mr-1'
      >
        View Raw
      </Button>
    </>
  );
};
